import type { PermissionCategory } from '@/permissions/permissions.catalog';

export type { PermissionCategory };

export const ROLE_COLORS: Record<string, string> = {
  owner: '#f59e0b',
  'co-owner': '#f59e0b',
  captain: '#818cf8',
  chef: '#34d399',
  steward: '#4ade80',
  mate: '#06b6d4',
  guest: '#a78bfa',
};
